var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 15.2c.26-.08.55-.06.8.06 1.3.58 2.17.81 3.76.81 4.28 0 7.63-3.26 7.63-7.16 0-3.89-3.35-7.15-7.63-7.15-4.3 0-7.62 2.99-7.62 7.15 0 1.55.55 2.53 1.11 3.52l.04.06c.16.3.2.64.1.96l-.78 2.43 2.59-.69Zm.3 1.15a9.1 9.1 0 0 0 4.26.92c4.88 0 8.83-3.74 8.83-8.36 0-4.61-3.95-8.35-8.83-8.35C4.1.56.14 3.99.14 8.9a7.68 7.68 0 0 0 1.3 4.18l-1.1 3.47a.6.6 0 0 0 .72.76l3.65-.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsmedium);
export default __webpack_public_path__ + "static/media/comments.medium.b8c4fc76aa1aad9235f61c2d7e3d04c6.svg";
export { ForwardRef as ReactComponent };